import { SE_IMPORT_FOREIGN_NAMESPACE, SE_IMPORT_FOREIGN_RELATIONS } from './serializedEachImportConstants';

/**
 * Is a completed `import:import` a Serialized Each bulk import?
 *
 * The client-visible signal is the virtual transaction relation the batch POSTed to. Both SE bulk
 * import paths qualify: the model+quantity path (`transaction:itemsByModel`) and the "Import from
 * RFID Tags" path (`transaction:itemByTagId`) — both stamp their items with `meta.import`, so both
 * warrant the personal "view this import" saved filter. Non-SE imports (e.g. plain `item:item`) and
 * individual POSTs are excluded.
 *
 * @param {Object} [newRecord] the import record (`data.newRecord`) — carries `foreignNamespace`/`foreignRelation`.
 * @returns {boolean}
 */
export default function isSerializedEachImport(newRecord) {
    return (
        newRecord?.foreignNamespace === SE_IMPORT_FOREIGN_NAMESPACE &&
        SE_IMPORT_FOREIGN_RELATIONS.includes(newRecord?.foreignRelation)
    );
}
